<template>
  <v-app-bar app absolute color="#4c2779" short style="z-index: 5">
    <v-row no-gutters>
      <v-col cols="6">
        <v-tabs dark hide-slider class="ml-1" background-color="#4c2779">
          <v-tab v-for="item in menuFiltrado" :key="item.url" :to="item.url">{{ item.nome }}</v-tab>
        </v-tabs>
      </v-col>

      <v-col xs="6" sm="6" md="6" lg="6" xl="6">
        <v-row class="d-flex justify-end">
          <v-col lg="5">
            <div class="classe">
              <div class="mr-3">
                <div v-if="$route.name == 'Multisign'">
                  <c-menu-ajuda></c-menu-ajuda>
                </div>
              </div>
              <div>
                <span
                  class="body-2 pt-1"
                  style="color: white; display: flex; "
                >{{dadosDoUsuario.email}}</span>
              </div>
            </div>
          </v-col>

          <v-col xs="1" sm="1" md="1" lg="1" xl="1" class="pl-0">
            <div class="icone-sair text-end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="white"
                    size="28px"
                    @click="deslogar"
                    class="mr-4"
                    v-on="on"
                  >mdi-exit-to-app</v-icon>
                </template>
                Sair
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import MenuAjuda from "../assinaturas/MenuAjuda";
export default {
  data() {
    return {};
  },
  methods: {
    deslogar() {
      localStorage.clear();

      this.$router.push("/");
    },
  },
  computed: {
    dadosDoUsuario() {
      return JSON.parse(localStorage.getItem("usuarioLogado"));
    },
    itensMenu() {
      return this.$store.state.itensMenu;
    },
    menuFiltrado() {
      let papel = this.dadosDoUsuario.papel;
      let menuFiltrado = this.itensMenu.filter((i) => {
        return i.liberadoPara.indexOf(papel) > -1;
      });
      return menuFiltrado;
    },
  },
  components: {
    "c-menu-ajuda": MenuAjuda,
  },
  created() {},
};
</script>
<style lang="css" scoped>
.classe {
  display: flex;
  justify-content: flex-end;
}
.icone-sair {
  left: 0px;
  position: relative;
}
</style>